import { AlertCircle } from 'lucide-react';
import type { ReactNode } from 'react';
import { cn } from '../cn';

// Brief §6 error chip: destructive label text on destructive-soft background tint,
// 1px destructive border, 2px radius, leading icon. Inline below the offending field
// or above the submit when global. role="alert" for screen-reader announcement.

export interface ErrorChipProps {
  children: ReactNode;
  className?: string;
  /** Suppress the leading icon (e.g., when the chip is inline below a field). */
  iconless?: boolean;
}

export function ErrorChip({ children, className, iconless = false }: ErrorChipProps) {
  return (
    <div
      role="alert"
      className={cn(
        'flex items-start gap-2 rounded-sm border border-destructive bg-destructive-soft/30 px-3 py-2 ' +
          'text-[12px] font-medium uppercase tracking-[0.05em] leading-[1.3] text-destructive-strong',
        className,
      )}
    >
      {!iconless && (
        <AlertCircle size={14} className="mt-[1px] shrink-0" aria-hidden="true" />
      )}
      <span className="normal-case font-normal tracking-normal text-[13px] leading-[1.4]">
        {children}
      </span>
    </div>
  );
}
